exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscriptionMb[data-v-0e84353c]{min-height:100vh;padding:66px 16px 16px;background-color:rgba(0,0,0,.02);font-family:Source Sans Pro;font-size:16px}.subscriptionMb[data-v-0e84353c] .afm-subscribe-container{width:100%;padding-top:60px}.subscriptionMb[data-v-0e84353c] .afm-subscribe-container .sub-header{font-size:12px;margin-bottom:0}.subscriptionMb[data-v-0e84353c] .afm-subscribe-container .sub-button-container{-webkit-transform:scale(.7);transform:scale(.7)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0e84353c","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/mobile/mobileEmail.vue
// module id = sy/R
// module chunks = 1